import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#1976D2',
        },
        secondary: {
            main: '#424242',
        },
        background: {
            default: '#FAFAFA',
            paper: '#F5F5F5',
        },
        text: {
            primary: '#212121',
            secondary: '#757575',
            disabled: '#BDBDBD',
        },
        successBright: {
            main: '#48a14b',
        },
        errorBright: {
            main: '#d32f2f',
        },
    },
    typography: {
        h1: {
            color: '#212121',
        },
        h2: {
            color: '#212121',
        },
        h3: {
            color: '#212121',
        },
        body1: {
            color: '#212121',
        },
        body2: {
            color: '#757575',
        },
    },
});

export default theme;
